"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_STATUS = void 0;
var ORGANIZATION_STATUS;
(function (ORGANIZATION_STATUS) {
    ORGANIZATION_STATUS["ACTIVE"] = "ACTIVE";
    ORGANIZATION_STATUS["PLAN_EXPIRED"] = "PLAN_EXPIRED";
    ORGANIZATION_STATUS["PENDING"] = "PENDING";
})(ORGANIZATION_STATUS || (exports.ORGANIZATION_STATUS = ORGANIZATION_STATUS = {}));
